/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateProductionSiteMutationRequest,
  UpdateProductionSiteMutationResponse,
  UpdateProductionSitePathParams,
} from "../types/UpdateProductionSite.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateProductionSiteMutationKey = () =>
  [{ url: "/v1/production-site/:productionSiteId" }] as const

export type UpdateProductionSiteMutationKey = ReturnType<
  typeof updateProductionSiteMutationKey
>

/**
 * @summary Edit a production site
 * {@link /v1/production-site/:productionSiteId}
 */
export async function updateProductionSite(
  productionSiteId: UpdateProductionSitePathParams["productionSiteId"],
  data: UpdateProductionSiteMutationRequest,
  config: Partial<RequestConfig<UpdateProductionSiteMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateProductionSiteMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateProductionSiteMutationRequest
  >({
    method: "PUT",
    url: `/v1/production-site/${productionSiteId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateProductionSiteMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateProductionSiteMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateProductionSiteMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productionSiteId: UpdateProductionSitePathParams["productionSiteId"]
      data: UpdateProductionSiteMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ productionSiteId, data }) => {
      return updateProductionSite(productionSiteId, data, config)
    },
  })
}

/**
 * @summary Edit a production site
 * {@link /v1/production-site/:productionSiteId}
 */
export function useUpdateProductionSite<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateProductionSiteMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        productionSiteId: UpdateProductionSitePathParams["productionSiteId"]
        data: UpdateProductionSiteMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateProductionSiteMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateProductionSiteMutationKey()

  const baseOptions = updateProductionSiteMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productionSiteId: UpdateProductionSitePathParams["productionSiteId"]
      data: UpdateProductionSiteMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productionSiteId: UpdateProductionSitePathParams["productionSiteId"]
      data: UpdateProductionSiteMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productionSiteId: UpdateProductionSitePathParams["productionSiteId"]
      data: UpdateProductionSiteMutationRequest
    },
    TContext
  >
}
